/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { useAppSelector } from '@redux/index'
import { View } from './View'

interface PropsType {
	children?: React.ReactNode
}

export const PageView = (props: PropsType) => {
	// redux state
	const backgroundColor: string = useAppSelector(state => state.config.backgroundColor)

	return <View css={[style, { background: backgroundColor }]}>{props.children}</View>
}

const style = css({
	position: 'relative',
	boxSizing: 'border-box',
	display: 'flex',
	width: '100%',
	minHeight: 'calc(100vh - 3.8rem)',
	marginRight: 0,
	borderRadius: '5px',
	padding: '1rem',
})
